/**
 * Data Cache - Simple TTL-based caching
 */
namespace appn.designerv2.dataCache {
    interface ICacheEntry {
        value: any;
        expiry: number;
    }

    let _cache = new Map<string, ICacheEntry>();
    let _cleanupInterval: number;
    let _defaultTTL = 300000; // 5 minutes

    export function init(defaultTTL: number = 300000) {
        _defaultTTL = defaultTTL;

        clearInterval(_cleanupInterval);
        _cleanupInterval = window.setInterval(() => {
            cleanup();
        }, 60000); // Every minute
    }

    export function get<T>(key: string): T | null {
        const entry = _cache.get(key);

        if (!entry) {
            return null;
        }

        if (Date.now() > entry.expiry) {
            _cache.delete(key);
            return null;
        }

        return entry.value as T;
    }

    export function set<T>(key: string, value: T, ttl: number = _defaultTTL): void {
        const entry: ICacheEntry = {
            value,
            expiry: Date.now() + ttl
        };
        _cache.set(key, entry);
    }

    export function del(key: string): void {
        _cache.delete(key);
    }

    export function clear(): void {
        _cache.clear();
    }

    export function has(key: string): boolean {
        const entry = _cache.get(key);
        if (!entry) return false;

        return Date.now() <= entry.expiry;
    }

    function cleanup(): void {
        const now = Date.now();
        const keysToDelete: string[] = [];

        for (const [key, entry] of _cache.entries()) {
            if (now > entry.expiry) {
                keysToDelete.push(key);
            }
        }

        keysToDelete.forEach(key => _cache.delete(key));
    }

    export function destroy(): void {
        clearInterval(_cleanupInterval);
        _cache.clear();
    }
}
